module.exports = __webpack_public_path__ + "img/white-wooden-kitchen-island-3264485.50b2c322.jpg";